import * as yup from 'yup'

export default class ObjectSchema extends yup.object {
  nonEmptyObject(msg: string) {
    return this.test({
      name: 'nonEmptyObject',
      exclusive: true,
      message: msg || 'Campo obligatorio',
      test: (value) => Object.keys(value).length > 0,
    })
  }
}
